export const LS_FAV_KEY = 'reactGithubFavorite';
export const LS_USERNAME_KEY = 'reactGithubUsername';
export const LS_TOTALPAGE_KEY = 'reactGitHubTotalPage';

export const PER_PAGE_SEARCH_USERS = 10;
export const PER_PAGE_USER_REPOS = 10;
